export default __webpack_public_path__ + "static/media/credit_cards.6dbd56d0.svg";